export const routes = [
  {
    path: '/instituicao',
    component: () => import(/* webpackChunkName: "ur" */ './components/List'),
    name: 'instituicao.list',
    meta: {
      requiresAuth: true
    }
  }
]
